import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'MR',
  name: 'Martín R.',
  location: 'Buenos Aires 🇦🇷',
  text: '"Compré un jueves. El viernes a la noche tenía el mes de entrenamientos listo. Nunca más improviso."'
}, {
  initials: 'CG',
  name: 'Carlos G.',
  location: 'Córdoba 🇦🇷',
  text: '"Tres jugadores de M13 que estaban estancados mejoraron el pase y el apoyo en el primer mes con el Tomo 3."'
}, {
  initials: 'LF',
  name: 'Lucas F.',
  location: 'Rosario 🇦🇷',
  text: '"Antes tardaba una hora armando cada entrenamiento. Ahora son 5 minutos y llego con todo claro al campo."'
}, {
  initials: 'PA',
  name: 'Pablo A.',
  location: 'Santa Fe 🇦🇷',
  text: '"El Banco de Correcciones cambió cómo le hablo a los jugadores. Ahora sé exactamente qué decir y cuándo."'
}, {
  initials: 'DR',
  name: 'Diego R.',
  location: 'Mendoza 🇦🇷',
  text: '"La Pretemporada Blindada me salvó este año. 22 jugadores disponibles para el primer partido. Cero lesionados."'
}, {
  initials: 'JM',
  name: 'Javier M.',
  location: 'Tucumán 🇦🇷',
  text: '"Las Jugadas Secretas las usé en el partido del sábado. Ganamos a un equipo que nos había goleado el año pasado."'
}];
export function ExtendedTestimonials() {
  return <section className="bg-[#F5F5F5] py-20 px-4" data-id="element-55">
      <div className="max-w-6xl mx-auto" data-id="element-56">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-12 flex items-center justify-center gap-3" data-id="element-57">
          Lo que dicen los entrenadores 4.9/5{' '}
          <Star className="fill-[#CCFF00] text-[#CCFF00] drop-shadow-[0_0_8px_rgba(204,255,0,0.5)]" size={32} data-id="element-58" />
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-59">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-60">
              <div className="flex items-center gap-4 mb-4" data-id="element-61">
                <div className="w-12 h-12 bg-[#39FF14] text-black rounded-full flex items-center justify-center font-bold text-lg flex-shrink-0" data-id="element-62">
                  {t.initials}
                </div>
                <div data-id="element-63">
                  <p className="font-bold text-gray-900" data-id="element-64">{t.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-65">{t.location}</p>
                </div>
              </div>
              <div className="flex gap-1 mb-4" data-id="element-66">
                {[...Array(5)].map((_, idx) => <Star key={idx} className="fill-[#CCFF00] text-[#CCFF00]" size={16} data-id="element-67" />)}
              </div>
              <p className="text-gray-700 italic flex-grow text-lg" data-id="element-68">{t.text}</p>
            </div>)}
        </div>
      </div>
    </section>;
}